module.exports = __webpack_public_path__ + "static/img/Capricorn.40e67ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/horoscope_icon/Capricorn.svg
// module id = 369
// module chunks = 0